import $ from './index'
import {QQCacheKey,RandomStr} from '../const'

const fetchQQFn = (qq,callback)=> {
    let cacheQQ = $.store.get(QQCacheKey)
    if(cacheQQ && cacheQQ['qq'] == qq) callback && callback(cacheQQ)
    else{
        // let link = '//users.qzone.qq.com/fcg-bin/cgi_get_portrait.fcg?uins='+qq
        // let cb = "JSONcallback_"+RandomStr,link = "//fly.pjax.cn/api/nic.php?qq="+qq+"&callback="+cb
        // $.sdkLoader(link,cb)
        // window[cb] = function (ret) {
        //     ret['qq'] = qq
        //     ret['pic'] = 'https://q2.qlogo.cn/headimg_dl?dst_uin='+qq+'&spec=100'
        //     $.store.set(QQCacheKey,ret)
        //     callback && callback(ret)
        //     $.deleteInWin(cb)
        // }
        $.ajax({
            type:'POST',
            url:'//valine.api.ioliu.cn/getqqinfo',
            data:{
                qq:qq
            },
            success(ret){
                if(!ret['errmsg']){
                    $.store.set(QQCacheKey,ret)
                    callback && callback(ret)
                }
            }
        })
    }
}

const recordIPFn = cb => {
    let cbName = 'JSONcallback_'+RandomStr();
    $.sdkLoader('//api.ip.sb/jsonip?callback='+cbName,cbName)
    // 获取IP
    window[cbName] = function (json) {
        cb && cb(json.ip)
        $.deleteInWin(cb)
    }
}

export {
    fetchQQFn,
    recordIPFn
}